import {
  DATA_CONNECTOR_CREATE_COLLECTION_WITH_APPWRITE_BEGIN,
  DATA_CONNECTOR_CREATE_COLLECTION_WITH_APPWRITE_SUCCESS,
  DATA_CONNECTOR_CREATE_COLLECTION_WITH_APPWRITE_FAILURE,
  DATA_CONNECTOR_CREATE_COLLECTION_WITH_APPWRITE_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';

export function createCollectionWithAppwrite(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_CREATE_COLLECTION_WITH_APPWRITE_BEGIN,
    });
    const header = builderSurfaceJsonContentHeader(args.projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${args.version}/appwrites/createwith-appwrite`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_CREATE_COLLECTION_WITH_APPWRITE_SUCCESS,
            data: res,
          });
          Mixpanel.track('Created Collection', {
            uuid: res.data.uuid,
            colletionName: res.data.colletionName,
          });
          toast.success('Collection Created Successfully !');
          resolve(res);
        },
        (err) => {
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          Mixpanel.track('Failed to creat collection');
          dispatch({
            type: DATA_CONNECTOR_CREATE_COLLECTION_WITH_APPWRITE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreateCollectionWithAppwriteError() {
  return {
    type: DATA_CONNECTOR_CREATE_COLLECTION_WITH_APPWRITE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_CREATE_COLLECTION_WITH_APPWRITE_BEGIN:
      return {
        ...state,
        createCollectionWithAppwritePending: true,
        createCollectionWithAppwriteError: null,
      };

    case DATA_CONNECTOR_CREATE_COLLECTION_WITH_APPWRITE_SUCCESS:
      return {
        ...state,
        createCollectionWithAppwritePending: false,
        createCollectionWithAppwriteError: null,
      };

    case DATA_CONNECTOR_CREATE_COLLECTION_WITH_APPWRITE_FAILURE:
      return {
        ...state,
        createCollectionWithAppwritePending: false,
        createCollectionWithAppwriteError: action.data.error,
      };

    case DATA_CONNECTOR_CREATE_COLLECTION_WITH_APPWRITE_DISMISS_ERROR:
      return {
        ...state,
        createCollectionWithAppwriteError: null,
      };

    default:
      return state;
  }
}
